import axios, {AxiosError, AxiosPromise, AxiosResponse} from 'axios';
const qs = require('qs');

export class SubmissionError {
    errors = [];
    message: string = "";
    constructor(errors: any, message: any) {
        this.errors = errors;
        this.message = message;
    }
}

function handleError(error: AxiosError) {
    const response = error.response;
    if (!!response && response.status === 422) {
        const errors = {};
        Object.keys(response.data.errors).forEach(key => {
            errors[key] = response.data.errors[key];
        });

        return new SubmissionError(errors, response.data.message);
    }

    return error;
}

function request(promise: AxiosPromise): Promise<any> {
    return new Promise((resolve, reject) => {
        promise
            .then((response: AxiosResponse) => {
                resolve(response.data);
            })
            .catch((error: AxiosError) => {
                reject(handleError(error));
            })
    });
}

export class Networking {
    public static get = (url: string, config: any) => {
        return request(axios.get(url, {
            ...config,
            paramsSerializer: params => qs.stringify(params, {arrayFormat: 'brackets'})
        }));
    };

    public static post = (url: string, config: any) => {
        return request(axios.post(url, config));
    };

    public static delete = (url: string, config: any) => {
        return request(axios.delete(url, config));
    };
}



// WEBPACK FOOTER //
// ./resources/js/utils/networking.ts